import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialogViewModel from "./../factories/bao-dialog";
import BaoMenu from "./../services/bao-menu";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import baoRouter from "./../services/bao-router";
function HolidayListViewModel(tabPage) {
    var self = this;
    self.Bao = Bao;
    var initialiazed = false;
    self.TabPage = tabPage;
    self.SelectedHolidayRow = ko.observable();
    self.HolidaylistPageIndex = ko.observable(0);
    self.HolidaylistPageSize = ko.observable(100);
    self.HolidaylistTotalRows = ko.observable(0);
    self.HolidaylistSorting = ko.observableArray();
    self.HolidaylistCollection = ko.observableArray([]);
    self.HolidayGroupByCollection = ko.observableArray([]);
    self.PersonId = ko.observable();
    self.FullName = ko.observable();
    self.Telephone = ko.observable();
    self.Number = ko.observable();
    self.HolidayDays = ko.observable();
    self.FilterYear = ko.observable();
    self.SelectedYear = ko.observable();
    self.HolidaylistSorting = ko.observableArray();
    self.IsReadonly = ko.observable(false);
    self.YearNumbers = ko.observableArray([]);
    self.TabName = ko.observable();
    tabPage.MenuEvents.push(BaoMenu.registerEvent(function (value) {
        if (tabPage != null && tabPage.IsActiveTab != null && tabPage.IsActiveTab() === true) {
            switch (value.ActionKey()) {
                case "HolidaylistRefresh":
                    self.RefreshPerson();
                    break;
            }
        }
    }));
    self.TabName.subscribe(function (newValue) {
        self.TabPage.Title(newValue);
    });
    self.SelectedYear.subscribe(function () {
        if (initialiazed) {
            initialiazed = false;
            self.HolidaylistPageIndex(0);
            initialiazed = true;
            self.RefreshHolidaylist();
        }
    });
    self.HolidaylistSorting.subscribe(function () {
        if (initialiazed) {
            self.RefreshHolidaylist();
        }
    });
    self.HolidaylistPageIndex.subscribe(function () {
        if (initialiazed) {
            self.RefreshHolidaylist();
        }
    });
    self.PersonId.subscribe(function (newValue) {
        if (initialiazed) {
            initialiazed = false;
            self.HolidaylistPageIndex(0);
            initialiazed = true;
            self.RefreshPerson(newValue);
        }
    });
    self.SelectHolidayRow = function (item) {
        self.SelectedHolidayRow(item);
        return true;
    };
    self.loadFilter = function () {
        return Bao.post("SynosetMasterData/GetYearCollection", JSON.stringify({}), function (result) {
            var DatumAkt = new Date();
            var JahrAkt = DatumAkt.getFullYear();
            for (var r in result) {
                if (result[r] != null)
                    self.YearNumbers.push(result[r]);
            }
            self.SelectedYear(JahrAkt);
            self.FilterYear(JahrAkt);
        });
    };
    self.PeformRefresh = function () {
        self.RefreshPerson();
    };
    self.RefreshHolidaylist = function () {
        tabPage.IsLoading(true);
        return Bao.post("Holidaylist/GetHolidaylistCollection", JSON.stringify({
            personId: self.PersonId(),
            filteryear: self.SelectedYear(),
            sorting: self.HolidaylistSorting(),
            pageIndex: self.HolidaylistPageIndex(),
            pageSize: self.HolidaylistPageSize()
        }), function (result1) {
            if (result1 != null && result1 != undefined) {
                self.HolidaylistCollection(result1.Models);
                self.HolidaylistTotalRows(result1.TotalRows);
                self.HolidayGroupByCollection(result1.HolidayGroupByCollection);
            }
            tabPage.IsLoading(false);
        });
    };
    self.RefreshPerson = function (personId) {
        tabPage.IsLoading(true);
        var def = $.Deferred();
        if (personId == null) {
            personId = self.PersonId();
        }
        Bao.post("Holidaylist/Get", JSON.stringify({
            personId: personId
        }), function (result) {
            ko.map.fromJS(result, self);
            self.RefreshHolidaylist().then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
    var baseLoaded = self.loaded;
    self.loaded = function () {
        if (baseLoaded != null) {
            baseLoaded.call(self);
        }
        initialiazed = true;
    };
    self.init = function () {
        var personId = baoRouter.getRouteValue("personId", self.TabPage);
        var def = $.Deferred();
        self.loadFilter().then(function () {
            self.RefreshPerson(personId).then(function () {
                def.resolve();
            });
        });
        return def.promise();
    };
}
export default HolidayListViewModel;